'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';

interface IFadeIn {
  key: string;
}

const FadeIn: FC<PropsWithChildren<IFadeIn>> = ({ key, children }) => {
  return (
    <AnimatePresence>
      <motion.div key={key} exit={{ opacity: 0 }} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default FadeIn;
